module.exports = __webpack_public_path__ + "img/catering_menu_14.b8db62f9.jpg";